var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('location-lookup',{attrs:{"lat":_vm.lat,"lng":_vm.lng},on:{"located":_vm.emitLocated},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }